export const PROPERTY_TYPE_MAPPING: { [type: string]: any } = {};
